export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Tag Families',
        category: 'User',
        description: 'Custom tag families assigned by the user to games, plays, and ratings.',
        summarise: {
            prefix: 'Family'
        },
        unit: 'family'
    },
    rules: {
        linked: [],
        legacy: ['tagfamilies']
    }
}